/**
 * @file info-circle.icon.tsx
 * @description Компонент для отображения иконки круга с восклицательным знаком.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const InfoCircleIcon = ({ className, size = '1.6937vmin', color = '#002033', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00011 -0.000244141C5.87835 -0.000244141 3.84349 0.842622 2.34318 2.34293C0.842866 3.84324 0 5.8781 0 7.99986C0 10.1216 0.842866 12.1565 2.34318 13.6568C3.84349 15.1571 5.87835 16 8.00011 16C10.1219 16 12.1567 15.1571 13.657 13.6568C15.1574 12.1565 16.0002 10.1216 16.0002 7.99986C16.0002 5.8781 15.1574 3.84324 13.657 2.34293C12.1567 0.842622 10.1219 -0.000244141 8.00011 -0.000244141ZM1.14753 7.99986C1.14753 6.18245 1.8695 4.43947 3.1546 3.15436C4.43971 1.86925 6.18269 1.14729 8.00011 1.14729C9.81752 1.14729 11.5605 1.86925 12.8456 3.15436C14.1307 4.43947 14.8527 6.18245 14.8527 7.99986C14.8527 9.81728 14.1307 11.5603 12.8456 12.8454C11.5605 14.1305 9.81752 14.8524 8.00011 14.8524C6.18269 14.8524 4.43971 14.1305 3.1546 12.8454C1.8695 11.5603 1.14753 9.81728 1.14753 7.99986ZM8.90605 4.37608C8.90605 4.61635 8.81061 4.84678 8.64071 5.01668C8.47081 5.18658 8.24038 5.28203 8.00011 5.28203C7.75984 5.28203 7.52941 5.18658 7.35951 5.01668C7.18961 4.84678 7.09416 4.61635 7.09416 4.37608C7.09416 4.13581 7.18961 3.90538 7.35951 3.73548C7.52941 3.56558 7.75984 3.47013 8.00011 3.47013C8.24038 3.47013 8.47081 3.56558 8.64071 3.73548C8.81061 3.90538 8.90605 4.13581 8.90605 4.37608ZM6.18822 6.18797H8.00011C8.16029 6.18797 8.31391 6.2516 8.42718 6.36487C8.54044 6.47813 8.60407 6.63175 8.60407 6.79194V11.0197H9.812V12.2276H6.18822V11.0197H7.39614V7.3959H6.18822V6.18797Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
